const lastUpdate = '2024-12-12';
export const helpTitle = 'Measuring Tool Help';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Measuring Tool allows you to measure distances, bearings, and areas directly on the map. It provides measurements in various units and displays the results in real-time.</p>

<h2>How to Use</h2>

<ol>
  <li><strong>Start Measuring:</strong>
    <ul>
      <li>Click the <i class="fas fa-ruler-combined"></i> icon to start measuring.</li>
      <li>The icon will turn red to indicate that the measuring tool is active.</li>
    </ul>
  </li>
  <li><strong>Measure Distance and Area:</strong>
    <ul>
      <li>Click on the map to start drawing your measurement path.</li>
      <li>Each click will add a new point to the path.</li>
      <li>as you go it will recacluate calculate the distance and area.</li>
    </ul>
  </li>
  <li><strong>View Measurements:</strong>
    <ul>
      <li>The measurements will be displayed in a panel, showing distance in kilometers and 
      nautical miles, and area in square kilometers, square meters, and hectares.</li>
    </ul>
  </li>
  <li><strong>Segments:</strong>
    <ul>
    <li>Open the segments section, by clicking the expand icon <i class="fas fa-circle-chevron-down"></i> </li>
      <li>Each segment of the path will be displayed with its length and bearing.</li>
      <li>Close the segments section by clicking the collapse icon <i class="fas fa-circle-chevron-up"></i></li>
      <li>Click the Delete segment icon <i class="fas fa-delete-left"></i> to remove the last segment.</li>
      <li>Click the trash icon <i class="fas fa-trash-can"></i> to remove all segments.</li>
    </ul>
  </li>
  <li><strong>Stop Measuring:</strong>
    <ul>
      <li>Click the <i class="fas fa-ruler-combined"></i> icon again to stop measuring.</li>
      <li>The icon will turn white to indicate that the measuring tool is inactive.</li>
      <li>All measurements will be cleared when you stop measuring.</li>
    </ul>
  </li>
</ol>

<h2>Additional Information</h2>
<p>The measuring tool disables map zooming with the mouse or by touch while active to ensure accurate 
measurements but you can still zoom in and out using the zoom buttons. You can re-enable these features by stopping the measuring tool.</p>

<p>To facilitate using the values you can use the "Copy to Clipboard" icon <i class="fas fa-clipboard"></i> to copy a result to the clipboard
or just use regular copy and paste actions.</p>

<p>For further assistance, please refer to the documentation or contact support.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;